import React, { FC } from 'react';

import { TextTagTypes } from '../text/text';

interface AccessibleDescriptionProps {
  /** Sets the HTML tag for the Accessible Description component */
  as?: TextTagTypes;
  /** The text that will be read by the screen reader */
  SRText: string;
  /** Makes text available to screen reader, but not visible in viewport */
  isForScreenReaderOnly?: boolean;
  /** Allows the component to get additional styles. */
  className?: string;
  /** HTML id for AccessibleDescription Component. */
  id?: string;
}

const AccessibleDescription: FC<AccessibleDescriptionProps> = ({
  as: Element = 'p',
  SRText,
  isForScreenReaderOnly = false,
  className,
  id = 'accessible-description'
}) => (
  <Element
    css={[
      { display: 'none' },
      isForScreenReaderOnly && {
        display: 'block',
        position: 'absolute',
        top: 'auto',
        left: '-10000px',
        height: '1px',
        width: '1px',
        overflow: 'hidden'
      }
    ]}
    // eslint-disable-next-line react/jsx-sort-props
    className={className}
    id={id}
  >
    {SRText}
  </Element>
);

export { AccessibleDescription };
export default AccessibleDescription;
